<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-12 mb-lg">
            <div class="card mb-3">
              <div class="card-body">
                <div
                  class="d-flex flex-column flex-lg-row align-items-center align-items-lg-start justify-content-between col-lg-12">
                  <div class="text-center text-lg-start col-12 col-lg-6 mb-3 mb-lg-0">
                    <h3>¡Bienvenid@ {{ name }}!</h3>
                  </div>
                  <div
                    class="d-flex flex-column flex-lg-row justify-content-center justify-content-lg-end col-12 col-lg-6 gap-2">
                    <div class="d-flex justify-content-center w-100 gap-2">
                      <button @click="$router.push('/hours')" class="btn btn-warning w-50 w-lg-auto mb-0">Registrar
                        Horas <i class="ni ni-time-alarm text-white opacity-10"></i></button>
                      <button @click="$router.push('/calendar')" class="btn btn-secondary w-50 w-lg-auto mb-0">Registrar
                        Eventos <i class="ni ni-calendar-grid-58 text-white opacity-10"></i></button>
                      <button @click="handleLogout" class="btn btn-danger w-50 w-lg-auto mb-0">Cerrar Sesión</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <sats-cards></sats-cards>
        <div class="row">
          <div class="col-lg-7 mb-lg">
            <!-- line chart -->
            <div class="card z-index-2">
              <HoursBarChart id="horas-chart" title="Comparativa de Horas"
                description="Horas a Capturar vs Horas Capturadas"  />
            </div>
          </div>
          <div class="col-lg-5">
            <carousel />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref} from 'vue'
import { useRouter } from 'vue-router';
import HoursBarChart from '../examples/Charts/HoursBarChart.vue';
import Carousel from "./components/Carousel.vue";

import SatsCards from "./components/SatsCards.vue";

const name = ref("")
const router = useRouter();


//Obtener info del token
import { jwtDecode } from "jwt-decode";
const token = localStorage.getItem("authToken");
if (token) {
  try {
    const decodedToken = jwtDecode(token);
    name.value = decodedToken.name
  } catch (error) {
    console.error("Error al decodificar el token:", error);
  }
} else {
  console.log("No hay token en localStorage");
}

const handleLogout = () => {
  if (confirm('¿Estás segur@ de cerrar la sesión ahora?')) {
    // Delete token from localStorage
    localStorage.removeItem("authToken");
    // Redirect user to login page
    router.push("/signin");
  }
};


</script>
